import { Trans, useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import { sendMessageToApp } from 'utils/exsternalCall';
import poster from 'assets/images/home/viggo-rivincita.webp';
import styles from './ViggoBanner.module.scss';

const TICKETS_URL =
  'https://viggoprofessional.it/evento/';

const openTickets = () => {
  if (localStorage.getItem('fromApp')) {
    sendMessageToApp('app:url', { url: TICKETS_URL });
    return;
  }
  window.open(TICKETS_URL, '_blank', 'noopener,noreferrer');
};

const ViggoBanner = () => {
  const { t } = useTranslation();

  return (
    <section className={styles.banner} aria-label={t('home.viggoBanner.aria')}>
      <div className={styles.copy}>
        <p className={styles.when}>{t('home.viggoBanner.when')}</p>
        <h2 className={styles.title}>
          <span className={styles.titleLine}>{t('home.viggoBanner.titleLine1')}</span>
          <span className={styles.titleLine}>{t('home.viggoBanner.titleLine2')}</span>
          <span className={styles.titleLine}>{t('home.viggoBanner.titleLine3')}</span>
        </h2>
        <p className={styles.desc}>
          <span className={styles.line}>
            <Trans
              i18nKey="home.viggoBanner.descriptionLead"
              components={{ strong: <strong /> }}
            />
          </span>{' '}
          <span className={styles.line}>
            <Trans
              i18nKey="home.viggoBanner.descriptionTail"
              components={{ code: <span className={styles.code} /> }}
            />
          </span>
        </p>
        <button type="button" className={styles.cta} onClick={openTickets}>
          {t('home.viggoBanner.cta')}
          <ArrowRight size={18} strokeWidth={2.4} aria-hidden />
        </button>
      </div>
      <div className={styles.poster} role="img" aria-label={t('home.viggoBanner.poster')}>
        <img src={poster} alt="" />
      </div>
    </section>
  );
};

export default ViggoBanner;
